import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";


type ccDeleteMesageDialogProps = {
    visible: boolean,
    onHide: () => void;
    onSubmit: () => void;

}

const AdminDeleteChatMessageDialog: React.FC<ccDeleteMesageDialogProps> = ({
    visible,
    onHide,
    onSubmit
}) => {
    const handleSubmit = () => {
        onSubmit();
    }

    const footer = (
        <div className="flex justify-end gap-2">
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button label="Confirmar" icon="pi pi-check" onClick={handleSubmit} />
        </div>
    );

    return (
        <Dialog
            header="¿Borrar mensaje?"
            visible={visible}
            modal
            onHide={onHide}
            style={{ width: '30vw' }}
            footer={footer}
        >
            <p>¿Está seguro que desea eliminar este mensaje?</p>
            <p>El mensaje se verá como eliminado para todos los integrantes del chat</p>

        </Dialog>
    )
}

export default AdminDeleteChatMessageDialog;